import AdvancedOrdersGrid from "components/pages/newOrders/AdvancedOrdersGrid";
const AdvancedOrders = () => {
    return (
        <AdvancedOrdersGrid />
    );
};

export default AdvancedOrders;
